import { CampaignState } from 'core/rtbCampaign/RtbCampaign';
import {
  CampaignDashboardWebService,
  RestfulCampaignDashboardWebService
} from 'ws/CampaignDashboardWebService';
import {
  AdTypeOptionType,
  CampaignDashboardRecord,
  DashboardSummaryInfo
} from './CampaignDashboard';

export interface CampaignDashboardManager {
  getSummaryInfo: (
    adType?: string,
    adTypeOptionType?: AdTypeOptionType
  ) => Promise<DashboardSummaryInfo[]>;

  getCampaignList: (
    day: number,
    adTypes?: string[],
    campaignStates?: CampaignState[],
    adTypeOptionTypes?: AdTypeOptionType[]
  ) => Promise<CampaignDashboardRecord[]>;
}

export class DefaultCampaignDashboardManager implements CampaignDashboardManager {
  webService: CampaignDashboardWebService;

  constructor(
    webService: CampaignDashboardWebService = new RestfulCampaignDashboardWebService()
  ) {
    this.webService = webService;
  }

  async getSummaryInfo(adType?: string, adTypeOptionType?: AdTypeOptionType) {
    return this.webService.getSummaryInfo(adType, adTypeOptionType);
  }

  async getCampaignList(
    day: number,
    adTypes?: string[],
    campaignStates?: CampaignState[],
    adTypeOptionTypes?: AdTypeOptionType[]
  ) {
    return this.webService.getCampaignList(
      day,
      adTypes,
      campaignStates,
      adTypeOptionTypes
    );
  }
}
